import classNames from "classnames";
import { useFormElementTestAttributes } from "core/components/testAttributes";
import { ElementType, ReactNode } from "react";
import styles from "./Label.module.scss";

export type LabelProps = React.HTMLProps<HTMLLabelElement>;
export interface Props {
    after?: ReactNode;
    as?: ElementType;
    label?: string;
    markRequired?: boolean;
    name?: string;
    className?: string;
}

export const Label = ({
    after,
    as: Component = "label",
    className,
    label,
    markRequired,
    name,
    ...rest
}: Props & LabelProps) => {
    const getTestAttributes = useFormElementTestAttributes();

    // prevent error if as is null or empty string
    if (!Component) {
        Component = "label";
    }

    return (
        <Component
            className={classNames(styles.label, className)}
            htmlFor={name}
            {...getTestAttributes("label", name)}
            {...rest}
        >
            {label}
            {markRequired && <span className={styles.required}>&nbsp;*</span>}
            {after}
        </Component>
    );
};
